module.exports = __webpack_public_path__ + "static/media/Logo_elRoundimage_831470.b5040e51.png";